import { create } from 'zustand';
import { apiKeyApi, IApiKey, IApiKeyCreate } from '../api';
import { getErrorMessageV2 } from 'shared/lib';
import { showError } from 'shared/api';

interface IState {
  apiKeys: IApiKey[];
  isLoadingList: boolean;
  isLoadingCreate: boolean;
  isLoadingDelete: boolean;
  confirmationDeleteModal: string | false;
}

interface IActions {
  fetchAll: () => Promise<void>;
  delete: (id: string) => Promise<void>;
  create: (data: IApiKeyCreate) => Promise<void>;
  toggleConfirmationDeleteModal: (value: string | false) => void;
}

export const apiKeyStore = create<IState & IActions>((set) => ({
  isLoadingList: false,
  isLoadingCreate: false,
  isLoadingDelete: false,
  showConfirmationDeleteModal: false,
  confirmationDeleteModal: false,
  apiKeys: [],
  toggleConfirmationDeleteModal: (value) => {
    set({ confirmationDeleteModal: value });
  },
  fetchAll: async () => {
    set({ isLoadingList: true });
    try {
      const response = await apiKeyApi.fetchAll();
      set({ apiKeys: response });
    } catch (error) {
      const message = getErrorMessageV2(error);
      showError(message);
    } finally {
      set({ isLoadingList: false });
    }
  },
  delete: async (id: string) => {
    set({ isLoadingDelete: true });
    try {
      await apiKeyApi.delete(id);
      set((state) => ({
        apiKeys: state.apiKeys.filter((apiKey) => apiKey.id !== id)
      }));
    } catch (error) {
      const message = getErrorMessageV2(error);
      showError(message);
    } finally {
      set({ isLoadingDelete: false });
    }
  },
  create: async (data: IApiKeyCreate) => {
    set({
      isLoadingCreate: true
    });
    try {
      const apiKey = await apiKeyApi.create(data);
      set((state) => ({
        apiKeys: [apiKey, ...state.apiKeys]
      }));
    } catch (error) {
      const message = getErrorMessageV2(error);
      showError(message);
    } finally {
      set({
        isLoadingCreate: false
      });
    }
  }
}));
